import React from 'react';
import './Signup.scss';

const Signup = props => {
  return (
    <div className='signup-outer-container'>
      <div>Hello World</div>
    </div>
  );
};

export default Signup;
